import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M12.913 5.913a.913.913 0 1 0-1.826 0v5.174H5.913a.913.913 0 1 0 0 1.826h5.174v5.174a.913.913 0 1 0 1.826 0v-5.174h5.174a.913.913 0 1 0 0-1.826h-5.174V5.913Z"
	})
});
const ForwardRef = forwardRef(SvgPlus);
export default ForwardRef;
